export default "__VITE_PUBLIC_ASSET__8ea3a6a0__"